// Affiche l'erreur au lieu d'une page blanche si un écran plante.

import { t } from '@shared/i18n';
import { Component, type ErrorInfo, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null; where: string }> {
  state = { error: null as Error | null, where: '' };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // détail technique pour le diagnostic (noms des fonctions et des écrans concernés)
    const stack = (error.stack ?? '').split('\n').slice(0, 6).join('\n');
    const screens = (info.componentStack ?? '').split('\n').filter(Boolean).slice(0, 6).join('\n');
    this.setState({ where: `${stack}\n--\n${screens}` });
    console.error(error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="container narrow" style={{ paddingTop: 40 }}>
        <div className="card stack">
          <h2 style={{ marginTop: 0 }}>{t('Oups, un problème est survenu', 'Oops, something went wrong')}</h2>
          <p className="muted" style={{ margin: 0 }}>
            {t(
              "Recharge la page. Si le problème persiste, envoie ce message à l'équipe FollowMe :",
              'Reload the page. If the problem persists, send this message to the FollowMe team:',
            )}
          </p>
          <pre style={{ whiteSpace: 'pre-wrap', margin: 0, fontSize: '0.85rem' }}>{this.state.error.message}</pre>
          {this.state.where && (
            <details>
              <summary className="muted small">{t('Détails techniques', 'Technical details')}</summary>
              <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.75rem' }}>{this.state.where}</pre>
            </details>
          )}
          <div>
            <button className="btn" onClick={() => location.reload()}>
              {t('Recharger', 'Reload')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
